export default __webpack_public_path__ + "static/reactmini-eac70b07fddc1afe97e768c1dea04017.png";